export const datetimeFormats = {
  "en-US": {
    full: {
      // These options are passed to Intl.DateTimeFormat

      dateStyle: "full",

      timeStyle: "full",
    },

    short: {
      year: "numeric",

      month: "short",

      day: "numeric",
    },
    long: {
      year: "numeric",
      month: "short",
      day: "numeric",
      weekday: "short",
      hour: "numeric",
      minute: "numeric",
    },
  },

  "ar-EG": {
    full: {
      dateStyle: "full",

      timeStyle: "full",
    },

    short: {
      year: "numeric",

      month: "long",

      day: "numeric",
    },
    long: {
      year: "numeric",
      month: "short",
      day: "numeric",
      weekday: "short",
      hour: "numeric",
      minute: "numeric",
    },
  },
};
